// Copy for the "AI-Powered. Human-Guided." band — screenshot-matched, same
// pattern as highlightsConfig's MAP_COPY: kept in one exported constant so
// the text has a single place to edit instead of being buried in JSX.
export const AI_POWERED_COPY = {
  title: 'AI-Powered. Human-Guided.',
  body: 'We use artificial intelligence to create, translate, illustrate, and distribute content faster and at scale. But every book is reviewed by real people—educators, translators, and community members—to ensure accuracy, quality, and cultural relevance.',
};
